export default "__VITE_ASSET__DcAzM0XU__"